module.exports = __webpack_public_path__ + "static/img/typeFour.42bbe8dc.png";